(function() {
  'use strict';

  angular.module('component.bulkActions')
    .component('bulkActionViewComponent', {
      templateUrl: 'app/components/bulk-actions/bulk-action-view.html',
      controller: 'BulkActionViewController',
      controllerAs: 'bulkActionViewCtrl',
      bindings: {
        bulkActionId: '<'
      }
    });
})();
